<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
  <div class="top">
    <a routerLink="/home/vacations/drivers/exercise/{{ id }}/{{ year }}">
      <h3>Chóferes / Ejercicio {{ year }}/</h3>
      <div class="breadcrumb">
        <mat-icon svgIcon="arrow back"></mat-icon>
        <h2>{{ operative?.name }}</h2>
      </div>
      <div class="subtitle background">
        <mat-icon>check_circle</mat-icon>
        Período de vacaciones <strong>inicial</strong> activo (01/08/2026 -
        08/08/2026)
      </div>
    </a>
    <div class="boton">
      <button class="b1" mat-button>Editar protocolo</button>
      <button class="b1" mat-button>Editar operativa</button>
    </div>
  </div>

  <div class="header-cards">
    <!-- TODO: Hacer componente de card -->
    <div class="card">
      <div class="title">CAMIONES DISPONIBLES</div>
      <div class="numbers">
        @if (operative && operative.stats && operative.stats.camiones &&
        operative.stats.camiones.actual == operative.stats.camiones.total) {
        <mat-icon id="check">check_circle</mat-icon>
        } @else {
        <mat-icon>error</mat-icon>
        }
        <span>{{ operative?.stats?.camiones?.actual || 0 }}</span>
        /{{ operative?.stats?.camiones?.total || 0 }}
      </div>
    </div>

    <div class="card">
      <div class="title">CHÓFERES DISPONIBLES</div>
      <div class="numbers">
        @if (operative && operative.stats && operative.stats.conductores &&
        operative.stats.conductores.actual == operative.stats.conductores.total)
        { <mat-icon id="check">check_circle</mat-icon>
        } @else {
        <mat-icon>error</mat-icon>
        }
        <span>{{ operative?.stats?.conductores?.actual || 0 }}</span>
        /{{ operative?.stats?.conductores?.total || 0 }}
      </div>
    </div>
  </div>
</div>

<div class="content">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="CALENDARIO">
      <div class="calendar">
        <app-horizontal-calendar
          [weeks]="calendarWeeks"
          [isLoading]="isLoadingCalendar"
          [refreshingWeekNumber]="refreshingWeekNumber"
          (refreshWeek)="onRefreshWeek($event)"
          (weekUpdated)="onWeekUpdated()"
        >
        </app-horizontal-calendar>
      </div>
    </mat-tab>

    <mat-tab label="PETICIONES PENDIENTES">
      <app-petitions
        [onlyPetitions]="true"
        [operativeId]="operativeId"
        [exerciseId]="id"
      ></app-petitions>
    </mat-tab>

    <mat-tab label="CHÓFERES">
      <app-petitions
        [onlyPetitions]="false"
        [operativeId]="operativeId"
        [exerciseId]="id"
      ></app-petitions>
    </mat-tab>

    <mat-tab label="PROTOCOLOS"> </mat-tab>
  </mat-tab-group>
</div>
